import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropDownOptionsComponent } from './drop-down-options.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';

@NgModule({
    declarations: [
        DropDownOptionsComponent
    ],
    imports: [
        CommonModule,
        SvgIconModule,
        MatListModule,
        MatMenuModule,
    ],
    exports: [
        DropDownOptionsComponent
    ]
})
export class DropDownOptionsModule { }
